<template>
  <v-text-field
    v-if="login"
    v-bind="$attrs"
    :outlined="layoutShape.textField === 'outlined'" :solo="layoutShape.textField === 'solo'"
    :filled="layoutShape.filledTextField" :rounded="layoutShape.roundTextField"
    :height="layoutShape.dropdown === 'outlined' || layoutShape.dropdown === 'solo' ? 50 : ''"
    color="elements"
    class="baseTextField"
    @keydown.enter="emitEnterPress"
    v-on="$listeners">
    <slot slot="label" name="label" />
    <slot slot="append" name="append" />
    <slot slot="append-outer" name="append-outer" />
  </v-text-field>
  <v-text-field
    v-else
    v-bind="$attrs"
    color="elements"
    :outlined="layoutShape.textField === 'outlined'" :solo="layoutShape.textField === 'solo'"
    :filled="layoutShape.filledTextField" :rounded="layoutShape.roundTextField"
    :height="layoutShape.dropdown === 'outlined' || layoutShape.dropdown === 'solo' ? 50 : ''"
    hide-details="auto"
    class="baseTextField"
    @keydown.enter="emitEnterPress"
    v-on="$listeners">
    <slot slot="label" name="label" />
    <slot slot="append" name="append" />
    <slot slot="append-outer" name="append-outer" />
  </v-text-field>
</template>
<script>
import { eventBus } from '../../main.js'
export default {
  name: 'BaseTextField',
  props: ['login'],
  data () {
    return {
      layoutShape: null,
    }
  },
  computed: {
    activeTool () {
      return this.$store.getters.getActiveTool
    },
  },
  created () {
    this.layoutShape = this.$store.getters.getConfigJson.layoutShape
  },
  mounted () {
    const selectedDomNodes = document.querySelectorAll('div.baseTextField input[type=text]')
    if (selectedDomNodes) {
      for (const domNode of selectedDomNodes) {
        domNode.classList.add('widgetsText--text')
      }
    }
  },
  methods: {
    emitEnterPress () {
      eventBus.$emit('enter-pressed', this.activeTool)
    },
  },
}
</script>
<style scoped>
.baseTextField>>>.v-text-field__slot input {
  font-weight: 500 !important;
}
.v-input>>>.v-label {
    font-size: 14px;
}
.v-input>>>.v-icon.v-icon {
  font-size: 18px;
}
</style>
